import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../styles/QuoteAccept.css";

export default function QuoteAccept() {
  const { t } = useTranslation();
  const { token } = useParams();

  const [quote, setQuote] = useState(null);
  const [loading, setLoading] = useState(true);
  const [accepting, setAccepting] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    loadQuote();
  }, [token]);

  const loadQuote = async () => {
    try {
      const response = await fetch(`/api/public/quotes/${token}`);

      if (!response.ok) {
        throw new Error();
      }

      setQuote(await response.json());
    } catch {
      setError(t("quotes.notFound"));
    } finally {
      setLoading(false);
    }
  };

  const acceptQuote = async () => {
    try {
      setAccepting(true);

      const response = await fetch(`/api/public/quotes/${token}/accept`, {
        method: "POST",
      });

      if (!response.ok) {
        throw new Error();
      }

      setQuote(await response.json());
    } catch {
      setError(t("quotes.acceptError"));
    } finally {
      setAccepting(false);
    }
  };

  if (loading) {
    return (
      <main className="quote-accept-page">
        <p>{t("common.loading")}</p>
      </main>
    );
  }

  if (error) {
    return (
      <main className="quote-accept-page">
        <section className="quote-card">
          <h1>{t("quotes.errorTitle")}</h1>
          <p>{error}</p>
        </section>
      </main>
    );
  }

  return (
    <main className="quote-accept-page">
      <section className="quote-card">
        <h1>{t("quotes.title")}</h1>

        <p>
          <strong>{t("quotes.number")}:</strong> {quote.quoteNumber}
        </p>

        <p>
          <strong>{t("quotes.customer")}:</strong> {quote.customerName}
        </p>

        <p>
          <strong>{t("quotes.amount")}:</strong>{" "}
          {Number(quote.amount).toFixed(2)} €
        </p>

        <p>
          <strong>{t("quotes.status")}:</strong>{" "}
          {t(`quotes.statuses.${quote.status}`)}
        </p>

        {quote.pdfFileUrl && (
          <a
            href={quote.pdfFileUrl}
            target="_blank"
            rel="noreferrer"
            className="quote-pdf-link"
          >
            {t("quotes.viewPdf")}
          </a>
        )}

        {quote.status === "ACCEPTED" ? (
          <div className="quote-success">
            {t("quotes.acceptedMessage")}
          </div>
        ) : (
          <button
            type="button"
            className="quote-accept-button"
            onClick={acceptQuote}
            disabled={accepting}
          >
            {accepting ? t("quotes.accepting") : t("quotes.acceptButton")}
          </button>
        )}

        {quote.expiresAt && (
          <p>
            <strong>{t("quotes.expiresAt")}:</strong>{" "}
            {new Date(quote.expiresAt).toLocaleDateString()}
          </p>
        )}
      </section>
    </main>
  );
}